import { render, staticRenderFns } from "./BidderPersonalEvaluationsHistoryView.vue?vue&type=template&id=6cf7b7b0&scoped=true&"
import script from "./BidderPersonalEvaluationsHistoryView.vue?vue&type=script&lang=js&"
export * from "./BidderPersonalEvaluationsHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf7b7b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable,VFlex,VIcon,VLayout,VSelect})
